"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScolapassInvoicesMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
const _1 = require(".");
class ScolapassInvoicesMapper {
    toDomain(result) {
        const scolapassInvoiceMapper = new _1.ScolapassInvoiceMapper();
        const hasNextPage = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.invoices.pageInfo.hasNextPage");
        const isLoading = lodash_1.default.get(result, "loading");
        const rawScolapassInvoices = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.invoices.edges");
        const scolapassInvoices = rawScolapassInvoices.map((_pay) => scolapassInvoiceMapper.toDomain(_pay));
        return {
            isLoading,
            hasNextPage,
            scolapassInvoices,
        };
    }
}
exports.ScolapassInvoicesMapper = ScolapassInvoicesMapper;
